import { ApiResponse } from 'apisauce';
import { ErrorInfo } from '../shared/interfaces/error-info.interface';
import { ResponseModel } from '../shared/interfaces/response-model.interface';
import UserMapper from '../shared/mappers/user.mapper';
import { UserModel } from '../shared/models/user.model';
import api from '../shared/services/utils/api/api.service';
import errorHelper from '../shared/services/utils/api/error-helper.service';
import { UserUIModel } from '../shared/ui-models/user.ui-model';

const MODULE_NAME = 'SALES_PERSONS_MODULE';

export function getSalesPersons(): Promise<UserUIModel[] | ErrorInfo> {
  return api
    .getSalesPersons()
    .then((response: ApiResponse<ResponseModel<UserModel[]>, ErrorInfo>) => {
      if (response.ok) {
        const { data } = response;
        if (data && data.data) {
          return UserMapper.mapToUIList(data.data);
        }
        return errorHelper(0, '', MODULE_NAME, (api.getSalesPersons as any).displayName);
      }

      return errorHelper(
        Number(response.status),
        response.data && response.data.errorCode
          ? String(response.data.errorCode || '')
          : response.problem,
        MODULE_NAME,
        (api.getSalesPersons as any).displayName
      );
    });
}

export function createSalesPerson(
  userUIModel: Partial<UserUIModel>
): Promise<UserUIModel | ErrorInfo> {
  const mappedUser = UserMapper.mapToModel(userUIModel);

  return api
    .createSalesPerson(mappedUser)
    .then((response: ApiResponse<ResponseModel<UserModel>, ErrorInfo>) => {
      if (response.ok) {
        const { data } = response;
        if (data && data.data) {
          return UserMapper.mapToUI(data.data);
        }
        return errorHelper(0, '', MODULE_NAME, (api.createSalesPerson as any).displayName);
      }

      return errorHelper(
        Number(response.status),
        response.data && response.data.errorCode
          ? String(response.data.errorCode || '')
          : response.problem,
        MODULE_NAME,
        (api.createSalesPerson as any).displayName
      );
    });
}
